
import { PageRequest } from "@/store/shared/entity";
import CreateCustomsDeclarationElement from "./component/create-customs-declaration-element.vue";
import EditCustomsDeclarationElement from "./component/edit-customs-declaration-element.vue";
import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins } from "@/lib";

class PageCustomsDeclarationElementRequest extends PageRequest {
  commoditycode: string;
}

@Component({
  name: "customsdeclarationelement",
  components: { CreateCustomsDeclarationElement, EditCustomsDeclarationElement },
})
export default class Factorys extends Mixins(PageResultBaseMixins, PageResultModalMixins) {
  buttons = { ...this.addBtn() };

  data: any = {
    model: new PageCustomsDeclarationElementRequest(),
    queryAction: "system/customsdeclarationelement/getAll",
    isAutoQuery: true,
    cols: this.columns,
  };

  get columns() {
    return [
      { title: this.L("app.CustomsDeclarationElement.CommodityCode"), key: "commodityCode" },
      { title: this.L("app.CustomsDeclarationElement.CommodityDescription"), key: "commodityDescription" },
      {
        title: this.L("app.CustomsDeclarationElement.ElementList"),
        key: "factoryNameAndAmount",
        minWidth: 260,
        render: (h, { row }) => {
          let list = row.elementList;
          let result = [];
          if (list) {
            list.forEach((item, index) => {
              result.push(h("span", {}, item.elementNo + ":" + item.element + ";"));
            });
          }

          return h("div", {}, result);
        },
      },
      this.$util.render.actions(this.colButtons),
    ];
  }

  colButtonCheck = (row) => {
    return !row.isStatic;
  };

  get colButtons(): ActionButtonConfig[] {
    return [this.colEditBtnM((row) => this.colButtonCheck(row)), this.colDeleteBtn((row) => this.colButtonCheck(row))];
  }

  async created() {
    // await this.$store.dispatch({
    //     type:'system/factory/getRoles'
    // })
  }

  reset() {
    this.data.model = new PageCustomsDeclarationElementRequest();
  }
}
